export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/3fadfda14f341399d663fd2ed398d959.svg";